import { render } from "./view-manager-embedded-module.vue?vue&type=template&id=ac72e81a&scoped=true"
import script from "./view-manager-embedded-module.vue?vue&type=script&lang=js"
export * from "./view-manager-embedded-module.vue?vue&type=script&lang=js"

import "./view-manager-embedded-module.vue?vue&type=style&index=0&id=ac72e81a&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604161159/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac72e81a"]])

export default __exports__